import { AccountPairOverride } from '@api/core';
import { ExportHeaderModel } from '@shared/export/export-interfaces';
import { isDefined } from '@stillmandigital/common';
import { sortBy } from 'lodash';
import { AccountPairOverrideViewModel, ExportPairModel, PairWithRouteModel } from './routes.interfaces';

export function getWarnMessage(isLpActive: boolean, isLpPairActive: boolean) {
  if (!isLpActive) {
    return 'LP is not active';
  }

  if (!isLpPairActive) {
    return 'Pair is not active';
  }

  return undefined;
}

export function createExportFileModel(pairs: PairWithRouteModel[]) {
  const headers: ExportHeaderModel<ExportPairModel>[] = [
    { fieldKey: 'name', fieldName: 'Symbol' },
    { fieldKey: 'qtyScale', fieldName: 'Qty scale' },
    { fieldKey: 'priceScaleView', fieldName: 'Price scale' },
    { fieldKey: 'minPrice', fieldName: 'Min price (updated each 30 minutes)' },
    { fieldKey: 'maxPrice', fieldName: 'Max price (updated each 30 minutes)' },
    { fieldKey: 'minQty', fieldName: 'Min quantity (updated each 30 minutes)' },
    { fieldKey: 'maxQty', fieldName: 'Max quantity (updated each 30 minutes)' },
  ];

  return {
    rows: sortBy(pairs, ['name']),
    headers,
  };
}

export function toAccountPairOverrideViewModel(
  customCommissionRate: AccountPairOverride,
): AccountPairOverrideViewModel {
  const highestCommissionRate =
    !isDefined(customCommissionRate.askCommissionRate) && !isDefined(customCommissionRate.bidCommissionRate)
      ? undefined
      : Math.max(
          customCommissionRate.askCommissionRate ?? Number.NEGATIVE_INFINITY,
          customCommissionRate.bidCommissionRate ?? Number.NEGATIVE_INFINITY,
        );

  return {
    ...customCommissionRate,
    highestCommissionRate,
  };
}
